import { DropitState, getTranslationsByScope } from "../../reducers"
import { $getFieldsByFamilyTech, $getTechFamilies } from "../../requests"
import { result as convertTree } from "../../../utils/tree/index"

import { ActionTypes } from ".."
import { loadTree } from "./act_tree"
import { responseType, transform } from "../../../utils/http-res-handler"

export const fetchAllTechFamilies =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const state = getState()
    if (state.miscellaneous.techTree.isLoading) {
      return
    }

    dispatch({
      type: ActionTypes.START_FETCHING_TECH_FAMILIES,
      treeName: "techTree",
    })

    return $getTechFamilies()
      .then((res) =>
        transform(
          res,
          getTranslationsByScope(getState(), "toastrLabels"),
          responseType.json
        )
      )
      .then((response) => {
        const data = convertTree(response)
        dispatch(loadTree({ treeName: "techTree", rawData: response, data }))
      })
      .catch((err) =>
        dispatch({
          errorMessage: err.message,
          type: ActionTypes.FETCH_TECH_FAMILIES_FAIL,
          treeName: "techTree",
        })
      )
  }
